import { create } from 'zustand'
import type { ConflictItem } from '../../calendar-planning-overlay/model/checkCollisions'

export interface PauseEditState {
  editing: {
    kind: 'break' | 'tm'
    id?: number
    dayIso: string
    startIso: string
    endIso: string
    anchorRect: DOMRect
    conflicts: ConflictItem[]
  } | null
  openForBreak: (dayIso: string, startIso: string, endIso: string, anchorRect: DOMRect, conflicts: ConflictItem[]) => void
  openForTM: (id: number, dayIso: string, startIso: string, endIso: string, anchorRect: DOMRect, conflicts: ConflictItem[]) => void
  updateRange: (startIso: string, endIso: string, conflicts: ConflictItem[]) => void
  close: () => void
}

export const usePauseEditState = create<PauseEditState>((set) => ({
  editing: null,
  openForBreak: (dayIso, startIso, endIso, anchorRect, conflicts) =>
    set({ editing: { kind: 'break', dayIso, startIso, endIso, anchorRect, conflicts } }),
  openForTM: (id, dayIso, startIso, endIso, anchorRect, conflicts) =>
    set({ editing: { kind: 'tm', id, dayIso, startIso, endIso, anchorRect, conflicts } }),
  updateRange: (startIso, endIso, conflicts) =>
    set((s) => s.editing ? { editing: { ...s.editing, startIso, endIso, conflicts } } : s),
  close: () => set({ editing: null }),
}))
